import theme from "@/theme.js";
import colors from "@/theme.js";

const userDefaults = {
  uid: 0,
  displayName: "John Doe",
  about:
    "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  status: "online",
  userRole: "admin",
};

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {};

const getUserInfo = () => {
  let userInfo = {};

  Object.keys(userDefaults).forEach((key) => {
    userInfo[key] = userInfoLocalStorage[key]
      ? userInfoLocalStorage[key]
      : userDefaults[key];
  });

  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] == undefined && userInfoLocalStorage[key] != null)
      userInfo[key] = userInfoLocalStorage[key];
  });

  return userInfo;
};

const state = {
  AppActiveUser: getUserInfo(),
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: theme.mainLayoutType || "vertical",
  reduceButton: theme.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  theme: theme.theme || "light",
  themePrimaryColor: colors.primary,
  windowWidth: null,
};

export default state;
